import FilterBase from "./filter-base";
import FilterBox from "./filter-box";
import { FilterActiveValue } from "./active-filters";
import $ from "jquery";


export default class SelectFilter extends FilterBase {
    private selectElement: HTMLSelectElement;
    private selectedId: number;

    constructor(element: HTMLElement, filterBox: FilterBox) {
        super(element, filterBox);
        this.selectElement = this.baseElement.querySelector('select');
    }

    public init(): void {
        this.addSelectChangeHandler();
    }

    protected setValuesInternal(values: string): Promise<void> {
        this.setFilterValue(Number(values));
        return Promise.resolve();
    }

    protected clearValuesInternal() {
        $(this.selectElement).prop('selectedIndex', -1);
    }

    public unselect(value: string){
        this.clear();
    }

    protected clear(): void {
        this.clearValues();
        this.filterBox.refreshFiltersAndProducts();
    }

    private addSelectChangeHandler() {
        this.selectElement.addEventListener('change', () => this.onSelectionChanged());
    }

    private onSelectionChanged(): any {
        const selectedId = this.getSelectedId();
        if (isNaN(selectedId) || selectedId <= 0)
            this.clearValues();
        else {
            this.setFilterValue(selectedId);
        }

        this.updateSelectedValuesAttribute();
        this.updateActiveFilterValues();
    }

    private setFilterValue(value: number){
        this.selectedId = value;
        this.selectElement.value = this.selectedId.toString();
    }

    protected getSelectedValuesConcat(): string {
        return this.selectedId ? this.selectedId.toString() : '';
    }

    protected getActiveFilterValues(): FilterActiveValue[] {
        if(!this.selectedId)
            return [];

        const selectedOption = this.selectElement.options[this.selectElement.selectedIndex];
        if(!selectedOption) {
            throw 'Selected option not found in select component';
        }

        return [<FilterActiveValue> { value: this.selectedId, displayName: selectedOption.text }];
    }

    private getSelectedId(): number {
        return Number(this.selectElement.value);
    }

}
